// extracted by mini-css-extract-plugin
export var tabBar = "styles-module__tabBar___S21qz";
export var submit = "styles-module__submit___U_Jxi";
export var prompt = "styles-module__prompt___PEL3v";
export var serverError = "styles-module__serverError___KvvUN";
export var body = "styles-module__body___p66PM";
export var planTypeCardCollection = "styles-module__planTypeCardCollection___vyvmj";
export var planType = "styles-module__planType___GNL4F";
export var changePlan = "styles-module__changePlan___Nrodj";